<template>
     <Modal  
        v-model="show" 
        :mask-closable="false"
        :loading="loading" 
        @on-ok="confirmHander" 
        @on-cancel="cancelHander">
        <div slot="header" class="modal-header">分配商机</div>
        <Form 
            :model="form" 
            :label-width="100"  
            :rules="formRules" 
            ref="form">
            <FormItem 
                label="分配商机数量" 
                v-if="fids">{{fids.length}}</FormItem>
            <FormItem 
                label="分配给" 
                prop="currentHandlerCode">
                <Select 
                    label-in-value
                    :value="form.currentHandlerCode" 
                    @on-change="getLabel">
                    <Option value="">请选择</Option>
                    <Option v-for="(item,index) in persion" :value="item.value" :key="index">{{item.text}}</Option>
                </Select>
            </FormItem>
            </Form>
     </Modal>
</template>
 
<script type="text/ecmascript-6">
import { getHandlePerson,allocateCooperation } from "@/api/ownerShip";
export default {
    name:'ASSIGNMODAL',
    props:{
        value:{
            type:Boolean,
            default:false
        },
        fids:{
            type:Array,
            default:null
        }

    },
    data () {
        return {
            show:false,
            form:{
                currentHandler:null,
                currentHandlerCode:null
            },
            formRules:{
                currentHandlerCode:[
                    { required: true, message: '请选择分配人员' ,trigger: 'change', type:'string'}
                ]
            },
            persion:[],
            loading:true
        }
    },
    watch: {
        value(val) {
            if(val){
                this.init();
            }
            this.show = val;
        },
        show(val) {
            if(!val){
                this.initData();
            }
            this.$emit('input',val)
        } 
    },  
    methods: {
        cancelHander() {
            this.show = false
        },
        init() {
            getHandlePerson().then(res => {
                console.log(res);
                this.persion = res.data;
            }) 
        },
        confirmHander() {
            this.$refs['form'].validate(bool => {
                if(!bool){
                    this.changeLoading();
                    return
                }
                let cooperationInfo = this.fids.map(item =>  {
                    return { cooperationFid : item }
                });
                allocateCooperation({
                    cooperationInfo,
                    currentHandler:this.form.currentHandler,
                    currentHandlerCode:this.form.currentHandlerCode
                })
                .then(res => {
                    this.$Message.success('商机分配成功');
                    this.$emit('refresh')
                    this.show = false;
                    this.changeLoading();
                }) 
                .catch(error => {
                    this.changeLoading();
                })
            })
        },
        changeLoading() {
            this.loading = false;
            this.$nextTick(() => {
                this.loading = true
            })
        },
        getLabel(val) {
            this.form.currentHandler = val.label;
            this.form.currentHandlerCode = val.value; 
        },
        initData() {
            this.form.currentHandler = null;
            this.form.currentHandlerCode = null;
            this.$refs['form'].resetFields();
        }
    }
}
</script>